// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qb1g","placeholdersHeader":"styles_placeholdersHeader__AxOFM","editorStyle":"styles_editorStyle__fn8rI","placeholdersBox":"styles_placeholdersBox__1Y9pO"};